import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../styles';

const Logo = ({ noAnimate = false, size }) => (
  <LogoWrapper size={size}>
    <LogoText
      initial={!noAnimate && theme.fadeIn.initial}
      animate={!noAnimate && theme.fadeIn.animate}
      transition={!noAnimate && theme.fadeIn.transition(0)}
    >
      Maru
    </LogoText>
    <LogoCircle
      initial={!noAnimate && theme.fadeIn.initial}
      animate={!noAnimate && theme.fadeIn.animate}
      transition={!noAnimate && theme.fadeIn.transition(theme.delaySm)}
    />
  </LogoWrapper>
);

const circleWidth = '2.75em';

const LogoWrapper = styled.div`
  position: relative;
  height: ${circleWidth};
  display: inline-flex;
  justify-content: center;
  font-size: ${props => (props.size ? props.size : props.theme.sizeH3)};
`;

const LogoText = styled(motion.h1)`
  margin: auto 0;
  font-size: inherit;
  background-color: ${props => props.theme.backgroundColor};
  z-index: 1;
`;

const LogoCircle = styled(motion.div)`
  position: absolute;
  top: 0;
  left: calc(50% - (${circleWidth} + 0.15em) / 2));
  width: ${circleWidth};
  height: ${circleWidth};
  border: 0.15em solid ${props => props.theme.brand};
  border-radius: ${props => props.theme.borderFull};
  z-index: -1;
`;

export default Logo;
